"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var hubspotPortal = 53;
var sidekickPortal = 250707;
var events = {
  SIDEKICK: {
    USED_PROSPECTS_DATE: {
      eventName: 'used_prospects_date',
      localSetting: 'usedProspectsDate',
      eventId: '000000180294',
      portalId: sidekickPortal,
      eventType: 'DATE'
    },
    USED_TEMPLATE_DATE: {
      eventName: 'sent_template_date',
      localSetting: 'sentTemplateDate',
      eventId: '000000180246',
      portalId: sidekickPortal,
      eventType: 'DATE'
    },
    USED_CRM_DATE: {
      eventName: 'used_crm_date',
      localSetting: 'usedCRMDate',
      eventId: '000000156015',
      portalId: sidekickPortal,
      eventType: 'DATE'
    },
    ADDED_PHONE_DATE: {
      eventName: 'added_phone_date',
      localSetting: 'addedPhoneDate',
      eventId: '000000180305',
      portalId: sidekickPortal,
      eventType: 'DATE'
    },
    MADE_CALL_DATE: {
      eventName: 'made_a_call_date',
      localSetting: 'madeCallDate',
      eventId: '000000180302',
      portalId: sidekickPortal,
      eventType: 'DATE'
    },
    USED_ACCELERATOR_DATE: {
      eventName: 'used_accelerator_date',
      localSetting: 'usedAcceleratorDate',
      eventId: '000000180476',
      portalId: sidekickPortal,
      eventType: 'DATE'
    }
  },
  HUBSPOT: {
    USED_CRM_DATE: {
      eventName: 'used_crm_date',
      localSetting: 'usedCRMDateHubSpotPortal',
      eventId: '000000212695',
      portalId: hubspotPortal,
      eventType: 'DATE'
    },
    FINISHED_SIGNUP_FLOW: {
      eventName: 'crm_finished_signup_flow',
      localSetting: 'crmSignupFlowFinished',
      eventId: '000000291342',
      portalId: hubspotPortal,
      eventType: 'FLAG'
    },
    CRM_ACTIVATED: {
      eventName: 'crm_activated',
      localSetting: 'activationViewedContactProfile',
      eventId: '000000212698',
      portalId: hubspotPortal,
      eventType: 'FLAG'
    },
    USED_TEMPLATE_DATE: {
      eventName: 'sent_template_date',
      localSetting: 'hsSentTemplateDate',
      eventId: '000000792307',
      portalId: hubspotPortal,
      eventType: 'DATE'
    },
    MADE_CALL_DATE: {
      eventName: 'made_a_call_date',
      localSetting: 'hsMadeCallDate',
      eventId: '000000792305',
      portalId: hubspotPortal,
      eventType: 'DATE'
    },
    CREATED_DEAL_DATE: {
      eventName: 'created_deal_date',
      localSetting: 'createdDealDate',
      eventId: '000000792299',
      portalId: hubspotPortal,
      eventType: 'DATE'
    },
    CREATED_CONTACT_VIEW_DATE: {
      eventName: 'created_contact_view_date',
      localSetting: 'createdContactViewDate',
      eventId: '000000792301',
      portalId: hubspotPortal,
      eventType: 'DATE'
    }
  }
};
var _default = events;
exports.default = _default;
module.exports = exports.default;